import { DashboardCard } from '@/common/dashboard/DashboardCard';
import { FilterContainer } from '@/common/dashboard/FilterContainer';
import { Form } from '@/common/form/Form';
import { useNavStateSync } from '@/common/hooks/navState/useNavStateSync';
import { MainBox } from '@/common/layout/MainBox';
import { Spacer, SpacerLayout } from '@/common/layout/SpacerLayout';
import { useNavState } from '@/common/navState/NavStateContext';
import { useRsrc } from '@/common/rsrc/RsrcContext';
import { Title } from '@/common/title/Title';
import { McdDispBreakdownPieChart } from '@/sc/entities/mcdInv/dashboard/fin/McdDispBreakdownPieChart';
import { McdDispTrendChart } from '@/sc/entities/mcdInv/dashboard/fin/McdDispTrendChart';
import { McdFinTopCtrtCard } from '@/sc/entities/mcdInv/dashboard/fin/McdFinTopCtrtCard';
import { fas } from '@awesome.me/kit-b4fd369ea4/icons';
import { Box } from '@mui/material';
import { useEffect, useState } from 'react';
import { DispTrendsCard } from './DispTrendsCard';
import { PaidTrendsCard } from './PaidTrendsCard';

export const McdFinDashboard = () => {

  const rsrc = useRsrc();
  const { navState } = useNavState();

  // Filters
  const [fieldDefs, setFieldDefs] = useState();
  const [formValues, setFormValues] = useNavStateSync('formValues');

  useEffect(() => {
    rsrc.data('sc', 'MCD_FIN_DASHBOARD_FILTER_DATA_PLUGIN', {}).then(res => {
      setFieldDefs([
        { field: 'rbtPeriodId', displayName: 'Rebate Period', type: 'DROPDOWN', values: res.periods },
        { field: 'stateIds', displayName: 'States', type: 'TREE', treeData: res.stateTreeData },
        { field: 'ctrtIds', displayName: 'Contracts', type: 'TREE', treeData: res.ctrtTreeData },
        { field: 'brandProdIds', displayName: 'Brands', type: 'TREE', treeData: res.brandProdTreeData },
      ])

      if (!navState.formValues) {
        setFormValues({
          rbtPeriodId: res.periods[0].value,
          stateIds: res.stateIds,
          ctrtIds: res.ctrtIds,
          brandProdIds: res.brandProdIds,
        });
      }
    });

  }, []);

  if (!fieldDefs) {
    return;
  }

  return (
    <MainBox>
      {/* Title */}
      <Box 
        sx={{
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'space-between',
          width: '100%',
          mb: 1
        }}
      >
        <Title icon={fas.faTasks} title="Medicaid Financial Dashboard" />
      </Box>
      {/* Filters */}
      <Form fieldDefs={fieldDefs} formValues={formValues} setFormValues={setFormValues} container={FilterContainer}/>

      {/* Main Contents */}
      <SpacerLayout>
        <Spacer vertical>
          {/* Row 1 */}
          <Spacer>
            <PaidTrendsCard formValues={formValues} />
            <DispTrendsCard formValues={formValues} />
          </Spacer>

          {/* Row 2 */}
          <Spacer weights={[5, 3, 5]}>
            <McdFinTopCtrtCard formValues={formValues} />

            <DashboardCard title="Dispute Code Breakdown" >
              <McdDispBreakdownPieChart formValues={formValues} />
            </DashboardCard>

            <DashboardCard title="Dispute Code Trends" >
              <McdDispTrendChart formValues={formValues} />
            </DashboardCard>
          </Spacer>
        </Spacer>
      </SpacerLayout>
    </MainBox>
  );
};